import { get, put, post, del, upload } from '@api/request';

export const fetchFirms = async (
  { litigationService },
  authenticationToken,
) => {
  const url = `${litigationService}/litigation/firms`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchFirm = async (
  { litigationService },
  authenticationToken,
  { firmID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchFirmFiles = async (
  { litigationService },
  authenticationToken,
  { firmID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}/files`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertFirm = async (
  { litigationService },
  authenticationToken,
  { payload },
) => {
  const url = `${litigationService}/litigation/firms`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertFirmFile = async (
  { litigationService },
  authenticationToken,
  { payload, firmID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updateFirm = async (
  { litigationService },
  authenticationToken,
  { payload, firmID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteFirm = async (
  { litigationService },
  authenticationToken,
  { firmID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const deleteFirmFile = async (
  { litigationService },
  authenticationToken,
  { payload, firmID, s3ID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const downloadFirmFile = async (
  { litigationService },
  authenticationToken,
  { firmID, s3ID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const search = async (
  { litigationService },
  authenticationToken,
  { pageSize, page, sortField, sortDirection, filterModel, payload },
) => {
  let url = `${litigationService}/litigation/firms/lookup?page=${page}&pageSize=${pageSize}`;

  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }

  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }

  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchFirmParties = async (
  { litigationService },
  authenticationToken,
  { firmID },
) => {
  const url = `${litigationService}/litigation/firm/${firmID}/parties`;
  const { body } = await get(authenticationToken, url);
  return body;
};
